import { useAppSelector } from '@/redux/hooks'
import { useEcommerceId } from './use-ecommerce-id'

// The cached settings keep the previous store's response while a newly selected store loads.
export function useStoreCurrency(): string {
  const ecommerceId = useEcommerceId()
  const settings = useAppSelector((s) => s.settingsApi.settings.response)
  return (
    (settings.ecommerce_id === ecommerceId && settings.currency_code) || 'EUR'
  )
}
